import Types from "./Types";

export const getSystemSubjectsRequest = (body) => ({
  type: Types.GET_SYSTEM_SUBJECTS_REQUEST,
  payload: body,
});

export const getSystemSubjectsSuccess = (data) => ({
  type: Types.GET_SYSTEM_SUBJECTS_SUCCESS,
  payload: data,
});

export const getSystemSubjectsFail = () => ({
  type: Types.GET_SYSTEM_SUBJECTS_FAIL,
});

export const addSubjectLoading = (isLoading) => ({
  type: Types.ADD_SUBJECTS_LOADING,
  payload: isLoading,
});
